import React from "react";
import {
  Box,
  Text,
  Badge,
  Image,
  VStack,
  HStack,
  Flex,
  SimpleGrid,
  Button,
} from "@chakra-ui/react";
import { BIZFLEX_README_DOCS_BASE } from "../../components/common/constants";

const ApiDeveloperExperience = () => {
  const features = [
    {
      icon: "assets/one.svg",
      title: "One API for multiple financial products",
      description:
        "Access all our services through a single, unified API. No need to manage multiple integrations or credentials.",
    },
    {
      icon: "assets/local.svg",
      title: "Local and global settlements",
      description:
        "Process payments in NGN and USD. Accept and send money locally and internationally with competitive rates.",
    },
    {
      icon: "assets/dev.svg",
      title: "Developer-friendly documentation",
      description:
        "Comprehensive guides, code samples, and interactive API reference. Get started in minutes, not days.",
    },
    {
      icon: "assets/fee.svg",
      title: "Competitive transaction fees",
      description:
        "Transparent pricing with no hidden fees. Pay only for what you use with our competitive rate structure.",
    },
    {
      icon: "assets/pricing.svg",
      title: "Flexible pricing for high-volume merchants",
      description:
        "Scale with confidence. Custom pricing available for businesses processing high transaction volumes.",
    },
    {
      icon: "assets/trust.svg",
      title: "Trusted by financial institutions and SMBs across Africa",
      description:
        "Join a growing community of businesses building the future of African fintech with BizFlex.",
    },
  ];

  return (
    <Box
      bgGradient="linear(to-b, #143885, #2463EB)"
      w="100vw"
      position="relative"
      left="50%"
      right="50%"
      ml="-50vw"
    >
      <Box
        w="100%"
        maxW="1326px"
        mx="auto"
        py={{ base: "60px", md: "100px" }}
        px={{ base: "20px", md: "80px", lg: "120px" }}
      >
        <VStack spacing="60px" align="center" w="100%">
          {/* Top Section */}
          <VStack spacing="24px" align="center" w="100%" maxW="1200px">
            <Badge
              display="flex"
              alignItems="center"
              gap="8px"
              w="fit-content"
              bg="blue.600"
              color="#FFFFFF"
              px="16px"
              py="6px"
              border="1px solid rgba(255, 255, 255, 0.2)"
              borderRadius="20px"
              fontSize="13px"
              fontWeight={600}
            >
              <Image
                src="assets/heart.svg"
                alt="heart"
                w="16px"
                h="16px"
              />
              Developer Experience
            </Badge>

            <Text
              fontSize={{ base: "28px", md: "42px", lg: "50px" }}
              fontWeight={600}
              textAlign="center"
              color="#FFFFFF"
              lineHeight="1.2"
            >
              Why Developers Love BizFlex
            </Text>

            <Text
              fontSize={{ base: "14px", md: "16px", lg: "18px" }}
              textAlign="center"
              color="rgba(255, 255, 255, 0.9)"
              maxW="800px"
              lineHeight="1.6"
            >
              Built by developers, for developers. Experience the difference
              with our powerful and intuitive API platform.
            </Text>
          </VStack>

          {/* Feature Cards Grid - 2x3 */}
          <SimpleGrid
            columns={{ base: 1, md: 2, lg: 3 }}
            spacing={{ base: "24px", md: "32px" }}
            w="100%"
            maxW="1200px"
          >
            {features.map((feature, index) => (
              <Box
                key={index}
                bg="blue.550"
                border="1px solid rgba(255, 255, 255, 0.2)"
                borderRadius="16px"
                p="32px"
                h="100%"
              >
                <VStack align="flex-start" spacing="16px" w="100%" h="100%">
                  {/* Icon */}
                  <Box
                    w="48px"
                    h="48px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexShrink={0}
                  >
                    <Image
                      src={feature.icon}
                      alt={feature.title}
                      w="48px"
                      h="48px"
                    />
                  </Box>

                  {/* Title */}
                  <Text
                    fontSize={{ base: "18px", md: "20px" }}
                    fontWeight={500}
                    color="#FFFFFF"
                    lineHeight="1.3"
                  >
                    {feature.title}
                  </Text>

                  {/* Description */}
                  <Text
                    fontSize={{ base: "14px", md: "16px" }}
                    color="rgba(255, 255, 255, 0.8)"
                    lineHeight="24px"
                  >
                    {feature.description}
                  </Text>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>

          {/* Call to Action Button */}
          <Flex justifyContent="center" w="100%" pt={{ base: "20px", md: "40px" }}>
            <Button
              as="a"
              href={BIZFLEX_README_DOCS_BASE}
              target="_blank"
              rel="noopener noreferrer"
              bg="#FFFFFF"
              borderRadius="12px"
              h="56px"
              w={{ base: "100%", md: "320px" }}
              px="24px"
              color="#2463EB"
              border="1px solid #2463EB"
              fontWeight={600}
              fontSize="16px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap="10px"
              _hover={{ bg: "#F1F5FE" }}
            >
              Explore the Documentations
              <Image
                src="assets/basil.svg"
                alt=""
                w="20px"
                h="20px"
              />
            </Button>
          </Flex>
        </VStack>
      </Box>
    </Box>
  );
};

export default ApiDeveloperExperience;

